module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.02,"color":"#198CDB","label":"<=2"},{"quantity":0.02,"color":"#91E3AD","label":"2-2.5"},{"quantity":0.025,"color":"#DEFFB0","label":"2.5-3"},{"quantity":0.03,"color":"#FFE68C","label":"3-4"},{"quantity":0.04,"color":"#FF9982","label":"4-6"},{"quantity":0.6,"color":"#FF4D30","label":">6"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_100_rice.json
// module id = WcX6
// module chunks = 171